module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("eW2he"))).then(() => parcelRequire('1iHdE'));